import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import PlayMode from "../../equalture/model/PlayMode";

export default class AppModel {
    static enforceCanvasScaling = false;
    static enforceOrientation = true;
    
    constructor() {
        this._language = null;
        this._isInterrupted = false;
        this._rtl = false;
    }

    set language(value) {
        if (!AppModel.SUPPORTED_LANGUAGES.contains(value)) {
            this._language = AppModel.FALLBACK_LANGUAGE;
            console.error(`Game launched with unsupported language '${value}' -- switched to fallback language '${this._language}'`);
        } else {
            this._language = value;
        }
        // Auto-set RTL based on language
        this._rtl = AppModel.RTL_LANGUAGES.includes(this._language);
    }

    get language() {
        return AppModel.debugLanguage || this._language;
    }

    get rtl() {
        return this._rtl;
    }

    set playMode(playMode) {
        this._playMode = playMode;
    }

    /** @type {PlayMode|string} */
    get playMode() {
        return AppModel.debugPlayMode || this._playMode || PlayMode.ASSESSMENT;
    }

    set environment(value) {
        this._environment = value;
    }

    get environment() {
        return this._environment;
    }

    set isInterrupted(value) {
        this._isInterrupted = value;
    }

    get isInterrupted() {
        return this._isInterrupted;
    }
}

//Static stuff:
AppModel.SUPPORTED_LANGUAGES = ["ar", "da", "de", "en", "es", "fi", "fr", "hu", "it", "ja", "nl", "no", "pl", "pt", "ro", "sv", "th", "tr", "vi", "zh"];
AppModel.RTL_LANGUAGES = ["ar"]; // Right-to-left languages
AppModel.FALLBACK_LANGUAGE = "en";
AppModel.languageFonts = {}; // Language-to-font mapping, populated during initialization
AppModel.languageFontSizes = {}; // Language-to-fontsize-mapping, populated during initialization

//Platforms
AppModel.isAndroid = /Android/i.test(navigator.userAgent);
AppModel.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
AppModel.isApple = AppModel.isIOS || /Mac|Macintosh/i.test(navigator.userAgent);
AppModel.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
AppModel.isPhone = AppModel.isMobile;//TODO: somehow exclude tablets here
AppModel.isTouch = window.ontouchstart !== undefined || getURLParameter("touch") == "1";

//Debug stuff    
if (getURLParameter("phone") != null) AppModel.isPhone = getURLParameter("phone") == "1";
if (getURLParameter("mobile") != null) AppModel.isMobile = getURLParameter("mobile") == "1";
AppModel.easterEggsEnabled = getURLParameter("easteregg") == "1";
